var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";
import { forwardRef } from "react";

const SvgSwap = (_ref, ref) => {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13589 1.4515C9.02685 1.7052 8.73328 1.81986 8.46996 1.73669C7.52817 1.4392 6.51529 1.42624 5.5602 1.70564C4.44449 2.03202 3.47738 2.73695 2.82516 3.6992C2.17295 4.66145 1.8764 5.82089 1.98651 6.97813C2.0693 7.84829 2.37814 8.67632 2.87573 9.38305L3.05222 7.94676C3.0859 7.67268 3.33539 7.4778 3.60947 7.51148C3.88355 7.54516 4.07844 7.79464 4.04476 8.06873L3.69375 10.9252C3.63366 11.4142 3.08223 11.6714 2.66902 11.4031L0.255183 9.83583C0.0235767 9.68546 -0.0422734 9.3758 0.108103 9.14419C0.258479 8.91258 0.568137 8.84674 0.799744 8.99711L1.8881 9.70375C1.39052 8.91425 1.08056 8.01409 0.991002 7.07285C0.858869 5.68417 1.21473 4.29284 1.99739 3.13813C2.78005 1.98343 3.94059 1.13751 5.27943 0.74586C6.45776 0.401161 7.70939 0.42729 8.86626 0.814036C9.12816 0.901589 9.24494 1.1978 9.13589 1.4515Z",
    fill: "#01040B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2874 3.29616L13.3757 4.00281C13.6073 4.15318 13.917 4.08733 14.0674 3.85573C14.2177 3.62412 14.1519 3.31446 13.9203 3.16409L11.5064 1.59684C11.0932 1.32856 10.5418 1.5857 10.4817 2.07468L10.1307 4.93119C10.097 5.20527 10.2919 5.45476 10.566 5.48844C10.8401 5.52212 11.0896 5.32724 11.1232 5.05316L11.2997 3.61687C11.7973 4.3236 12.1062 5.15162 12.189 6.02179C12.2991 7.17903 12.0025 8.33847 11.3503 9.30072C10.6981 10.263 9.73097 10.9679 8.61527 11.2943C7.66018 11.5737 6.6473 11.5607 5.7055 11.2632C5.44219 11.1801 5.14862 11.2947 5.03957 11.5484C4.93053 11.8021 5.04731 12.0983 5.30921 12.1859C6.46608 12.5726 7.71771 12.5988 8.89604 12.2541C10.2349 11.8624 11.3954 11.0165 12.1781 9.86178C12.9607 8.70708 13.3166 7.31575 13.1845 5.92707C13.0949 4.98582 12.785 4.08566 12.2874 3.29616Z",
    fill: "#01040B"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSwap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Swap.7ed41bc167e6c9b6f5083d270e0d8911.svg";